import { useEffect, useState } from "react";
import image4 from "../../Assets/images/create-assistant-img04.jpg";
import { useLocation, useNavigate } from "react-router-dom";
import { useDispatch } from "react-redux";
import { AddAssistant } from "../../Redux/Slice/Assistant/AddAssistantSlice";
import { ErrorModel } from "../../Model/ErrorModel";
import { assistantNameValidation, nameValidation } from "../../Common/Validations";
import { Loader } from "../../Common/Loader";
import { addFile } from "../../Common/indexDb";
import Image1 from "../../Assets/images/create-assistant-img01.jpg";
export const AddAssistantImage = (props) => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const location = useLocation();
  const [asstImage, setAsstImage] = useState();
  const [asstName, setAsstName] = useState("");
  const [errorMessage, setErrorMessage] = useState("");
  const [isLoading, setIsLoading] = useState(false);
  const [showErrorPopUp, setShowErrorPopup] = useState(false);
  const [nameError, setNameError] = useState("");
  const customerId = location.pathname.includes("/add-assistant/") || location.pathname.includes("/assistants/") || location?.pathname?.includes("/add-assistant-builder/") ? location.pathname.split("/")[2] : "";

  const handleChange = async (e) => {
    if(e?.target?.files && e?.target?.files && e.target.files?.length){
      setAsstImage(URL.createObjectURL(e.target.files[0]));
      await addFile(e.target.files[0], 1);
    }
    // setAsstImage(val);
  };

  useEffect(() => {
    if (props.selectedTemplate?.name) {
      setAsstName(props.selectedTemplate?.name);
    }
  }, [props]);

  const handelNameChange = (e) => {
    let value = e?.target?.value;
    const isValid = assistantNameValidation(value);
    if (isValid || value.trim() === "") {
      setNameError("");
    } else {
      setNameError("Please enter valid Assistant name");
    }
    let capitalized = value.charAt(0).toString().toUpperCase();
    value = capitalized + value.substring(1);
    setAsstName(value);
  };

  const handleSubmit = () => {
    props.closePopup(true);
    if (props.selectedTemplate) {
      navigate(customerId ? `/add-assistant/${customerId}`: '/add-assistant', {
        state: {
          details: props.selectedTemplate,
          name: asstName,
          avatar: asstImage ? undefined : props?.selectedTemplate?.avatar,
          from: "template",
          planType: location?.state?.planType,
          customerName: location?.state?.customerName,
        },
      });
    } else {
      navigate(customerId ? `/add-assistant/${customerId}`: '/add-assistant', { state: { name: asstName, from: "new",planType: location?.state?.planType, customerName: location?.state?.customerName } });
    }
  };
  // const handleSubmit = async () =>{
  //   setIsLoading(true);
  //   const result = await dispatch(AddAssistant({...props.selectedTemplate , name: asstName}));
  //   if (
  //     AddAssistant.fulfilled.match(result) &&
  //     result?.payload?.success === true
  //   ) {
  //     setIsLoading(false);
  //     props.closePopup();
  //     navigate("/add-assistant", {state:{selectedBotId: result?.payload?.data?.role?.id}});
  //   }else{
  //     setIsLoading(false);
  //     setErrorMessage(result?.payload?.error?.message);
  //     setShowErrorPopup(true);
  //   }

  // }
  return (
    <>
      {isLoading ? (
        <Loader />
      ) : (
        <div className="modal modal--createAssistant modal--open">
          {showErrorPopUp ? <ErrorModel message={errorMessage} /> : ""}
          <div className="modal__dialog">
            <div className="modal__content modal__content--lg">
              <div className="modal__header">
                <h1 className="modal__header--title">Create Assistant</h1>
                <p className="para">
                  Let’s customize your assistant! You can simply setup by giving
                  it a unique name.
                </p>
                <button
                  className="btn btn__transparent btnClose"
                  onClick={() => props.closePopup()}
                >
                  <svg
                    width="25"
                    height="24"
                    viewBox="0 0 25 24"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <rect
                      x="0.586914"
                      width="24"
                      height="24"
                      rx="12"
                      fill="#E5E5E5"
                    />
                    <path
                      d="M12.5869 10.8891L16.476 7L17.5869 8.11094L13.6979 12L17.5869 15.8891L16.476 17L12.5869 13.1109L8.69785 17L7.58691 15.8891L11.476 12L7.58691 8.11094L8.69785 7L12.5869 10.8891Z"
                      fill="#4F4F4F"
                    />
                  </svg>
                </button>
              </div>
              <div className="modal__body modal-body-left">
                <div className="createAssistant createAssistant--voicebot">
                  <div className="createAssistant__list">
                    <div className="createAssistant__item">
                      <label className="createAssistant__card">
                        {!asstImage && !props?.selectedTemplate?.avatar ? <svg
                          width="41"
                          height="41"
                          viewBox="0 0 41 41"
                          fill="none"
                          xmlns="http://www.w3.org/2000/svg"
                        >
                          <path
                            d="M20.5 3V38M3 20.5H38"
                            stroke="#1C1C1C"
                            stroke-opacity="0.28"
                            stroke-width="5"
                            stroke-linecap="round"
                            stroke-linejoin="round"
                          />
                        </svg> : null}
                        {asstImage ? (
                          <img src={asstImage} />
                        ) : props?.selectedTemplate?.avatar ? (
                          <img src={props?.selectedTemplate?.avatar} />
                        ) : null}
                        <input
                            id="uploadFile"
                            className="form__input"
                            type="file"
                            name="image"
                            onChange={handleChange}
                            accept="image/*"
                          />
                      </label>
                      <h3 className="title">Blank Template</h3>
                    </div>
                  </div>
                  <div className="formRow">
                    <div className="formCol">
                      <div className="form__Field">
                        <label for="voicebotName" className="form__label">
                          Assistant Name
                        </label>
                        <input
                          type="text"
                          id="voicebotName"
                          value={asstName}
                          maxLength={40}
                          onChange={handelNameChange}
                          name="voicebotName"
                          className="form__input form__input--sm"
                          placeholder="Assistant name"
                          spellcheck="false"
                        />
                      </div>
                      <div className="form__error">{nameError}</div>
                      <p className="para">
                        {/* This is a basic AI Asst. Template The charge will happen on
                    the day when your free credits will be expired within two
                    hours or less of the same time. */}
                      </p>
                    </div>
                  </div>
                </div>
              </div>
              <div className="modal__footer">
                <div className="btn__group">
                  <button
                    className="btn btn__white"
                    onClick={() => props.closePopup()}
                  >
                    Cancel
                  </button>
                  <button
                    className="btn btn__primary"
                    disabled={asstName.trim() === "" || nameError != ""}
                    onClick={handleSubmit}
                  >
                    Create new Assistant
                  </button>
                </div>
              </div>
            </div>
          </div>
          <div className="modal__backdrop"></div>
        </div>
      )}
    </>
  );
};
